// removed by extract-text-webpack-plugin
module.exports = {"headerRow":"_39wdQIMF5fflkx3BW8PK4W","headerTitle":"gCnF7jcd_h8tH6jGRXdRL","insidepane":"i8kCaXoXPoiJxD4e_Va9f","qpane":"_3nLGup518IB2z9uD22GgRi","qpaneSize":"_2oiBqg0QT9ZZb4iVt_4oal","question":"_1a_2vh61-2R8CRgoMdT0sh","gamble":"qlYSkqmD-zhOFG-0I7Ud4","gambleBox":"_3vdSVAhne-Nw32ZIrCIBMQ","answerButton":"_34xIi6PqyvCBot5JZN54ZW","stepOn":"_3IWxY9YeP7OWdgR6t2BjE0","stepOff":"T-FO9B_-R0XgAQyee2FFV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ClientMode/LossAversion.css
// module id = 716
// module chunks = 0